import React from 'react';
import { trustItems } from '../../data/kit';
export function TrustStrip() {
  return <section aria-label="Format and delivery" className="bg-petrol" data-id="element-200" data-mp="2sln22popekb1">
      <dl className="mx-auto grid max-w-[1180px] grid-cols-2 lg:grid-cols-4" data-id="element-201" data-mp="2snpypskd3boq">
        {trustItems.map((item, i) => <div key={item.label} className={`flex flex-col-reverse items-center border-white/10 px-3 py-7 text-center sm:py-9 ${i % 2 === 0 ? 'border-r' : ''} ${i < 2 ? 'border-b lg:border-b-0' : ''} lg:border-r lg:last:border-r-0`} data-id="element-202" data-mp="31mbdrdqmk8kr" data-mpi={i}>
            <dt className="mt-2 text-[11px] font-bold uppercase tracking-[.16em] text-white/70" data-id="element-203" data-mp="3gbhdr3xae2tp">{item.label}</dt>
            <dd className="font-display text-[34px] font-extrabold uppercase leading-none text-teal-light sm:text-[46px]" data-id="element-204" data-mp="3lb29z6l2nx2q">
              {item.value}
            </dd>
          </div>)}
      </dl>
    </section>;
}